import I18n from 'i18n-js';
import { RCSwitch } from '@reverbdotcom/cadence/components';
import { core_apimessages_ShippingLabelPackage } from '@reverbdotcom/commons/src/gql/graphql';
import React from 'react';

interface IProps {
  packageEntry: core_apimessages_ShippingLabelPackage;
  checked: boolean;
  onChange: () => void;
}

export default function ShippingReverbPackageDataToggle({ packageEntry, checked, onChange }: IProps) {
  if (!packageEntry) return null;

  const dimensions = `${parseInt(packageEntry.length.value)}x${parseInt(packageEntry.width.value)}x${parseInt(packageEntry.height.value)}${packageEntry.length.unit}`;
  const weight = `${parseInt(packageEntry.weight.value)}${packageEntry.weight.unit}`;

  return (
    <div className="reverb-package-data-toggle">
      <RCSwitch
        label={I18n.t('discovery.sellForm.shippingSection.domesticShippingCard.reverbPackageDataToggle.label')}
        sublabel={I18n.t('discovery.sellForm.shippingSection.domesticShippingCard.reverbPackageDataToggle.subLabel', {
          dimensions,
          weight,
        })}
        checked={checked}
        onChange={onChange} />
      <p className="reverb-package-data-toggle__description">
        {I18n.t('discovery.sellForm.shippingSection.domesticShippingCard.reverbPackageDataToggle.description')}
      </p>
    </div>
  );
}
